module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reverse DNS networks":"Reverse DNS networks","IP network":"IP network","IP version":"IP version","first IP":"First IP","last IP":"Last IP","number IPs":"Number IPs"},"de":{"reverse DNS networks":"Reverse DNS Netze","IP network":"IP Netz","IP version":"IP Version","first IP":"erste IP","last IP":"letzte IP","number IPs":"Anzahl IPs"}}')
  delete Component.options._Ctor
}
